<template>
  <page title="Payment">
    <div v-if="payInfo.paymentType ==='ZJ'" class="amount">{{cabinet.yajin}} {{cabinet.currencyName}}</div>
    <div v-else-if="payInfo.paymentType ==='CZ'" class="amount">{{payInfo.amount}} {{user.p_currency_name}}</div>

    <div v-if="list.length" class="title">{{i18n.choose}}</div>
    <div v-else class="title">{{i18n.no_card}}</div>
    <div v-for="item in list" :key="item.pid">
      <card-item @checked="checked" :item="item" :canCheck="true" :checkedId="cardId"></card-item>
    </div>
    <div v-if="list.length === 0 " class="btn" @click="handleToBindCard">{{i18n.bind_card}}</div>
    <div v-else class="btn" @click="handlePay">{{i18n.submit}}</div>
  </page>
</template>

<script>
import { mapState } from 'vuex'
import { CARD_LIST } from '../../apis/payment.js'
import CardItem from '../bankcard/components/CardItem.vue'
import { EVERYPAY_PRE_PAY, EVERYPAY_CONFIRM, EVERYPAY_PAY_ORDER, EVERYPAY_BALANCE_CHARGE } from '../../apis/cabinet'
export default {
  name: 'Payment',
  components: {
    CardItem
  },
  computed: {
    ...mapState(['cabinet', 'payInfo', 'user']),
    i18n () {
      return this.$t('payment')
    },
    i18nMsg () {
      return this.$t('msg')
    },
    i18nConfirm () {
      return this.$t('confirm')
    }
  },
  data () {
    return {
      cardId: '',
      order_reference: '',
      list: []
    }
  },
  created () {
    this.getCardList()
  },
  methods: {
    getCardList () {
      this.$loading(true)
      this.$get(
        CARD_LIST,
        {},
        (resp) => {
          this.$loading(false)
          this.list = resp.data
          if (this.list.length > 0) {
            this.cardId = this.list[0].pid
          }
        },
        (error) => {
          this.$loading(false)
          console.log(error)
        }
      )
    },
    checked (id) {
      this.cardId = id
    },
    handlePay () {
      this.$loading(true)
      switch (this.payInfo.paymentType) {
        case 'ZJ':
          this.$post(
            `${EVERYPAY_PRE_PAY}/${this.cabinet.qrcode}?cardId=${this.cardId}`,
            {},
            (resp) => {
              if (resp.code === 0) {
                this.$loading(false)
                const data = resp.data || {}
                this.order_reference = data.order_reference
                this.confirmOrder()
              }
            },
            (error) => {
              this.$loading(false)
              console.log(error)
              this.$confirm({
                title: this.i18nMsg.confirm,
                content: error,
                confirmText: this.i18nConfirm.msg_fail_confirm,
                showCancel: false
              })
                .then(() => {})
                .catch(() => {})
            }
          )
          break
        case 'PO':
          this.$post(
            `${EVERYPAY_PAY_ORDER}?orderId=${this.payInfo.orderId}&cardId=${this.cardId}`,
            {},
            resp => {
              this.$loading(false)
              if (resp.code === 0) {
                const data = resp.data
                console.log(data)
                if (data.payment_state === 'settled') {
                  this.$toast(this.i18nMsg.success)
                  this.$router.replace('/order')
                } else {
                  this.$toast(this.i18nMsg.title_fail)
                }
              }
            },
            error => {
              this.$loading(false)
              console.log(error)
              this.$confirm({
                title: this.i18nMsg.confirm,
                content: error,
                confirmText: this.i18nConfirm.msg_fail_confirm,
                showCancel: false
              }).then(() => {}).catch(() => {})
            })
          break
        case 'CZ': {
          this.$post(`${EVERYPAY_BALANCE_CHARGE}?amount=${this.payInfo.amount}&cardId=${this.cardId}`,
            {},
            resp => {
              this.$loading(false)
              if (resp.code === 0) {
                const data = resp.data
                console.log(data)
                if (data.payment_state === 'settled') {
                  this.$toast(this.i18nMsg.success)
                  this.$router.replace('/wallet')
                } else {
                  this.$toast(this.i18nMsg.title_fail)
                }
              }
            },
            error => {
              this.$loading(false)
              console.log(error)
              this.$confirm({
                title: this.i18nMsg.confirm,
                content: error,
                confirmText: this.i18nConfirm.msg_fail_confirm,
                showCancel: false
              }).then(() => {}).catch(() => {})
            })
        }
      }
    },
    handleToBindCard () {
      this.$router.push('/bankcard')
    },
    confirmOrder () {
      this.$confirm({
        title: this.i18nMsg.confirm,
        content: this.i18nMsg.success_payment,
        confirmText: this.i18nConfirm.msg_fail_confirm,
        cancelText: this.i18nConfirm.msg_fail_cancel
      }).then(() => {
        this.$loading(true)
        this.$post(`${EVERYPAY_CONFIRM}`,
          {
            order_reference: this.order_reference
          },
          resp => {
            this.$loading(false)
            if (resp.code === 0) {
              if (this.payInfo.paymentType === 'ZJ') {
                this.$router.push(`/result?tradeNo=${this.order_reference}`)
              }
            }
            // console.log(resp)
          },
          error => {
            console.log(error)
            this.$loading(false)
            this.confirmOrder()
          }
        )
      }).catch(() => {
        location.hash = ''
      })
    }
  }
}
</script>

<style lang="less" scoped>
.amount {
  padding: 20px;
  text-align: center;
  font-size: 60px;
}
.title {
  text-align: left;
  padding: 30px 20px 20px 60px;
  font-size: 35px;
  border-top: 1px solid #ccc;
}
.btn {
  position: fixed;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  width: 60%;
  height: 80px;
  line-height: 80px;
  border-radius: 8px;
  color: #fff;
  background-color: #3ca2fc;
  text-align: center;
  font-size: 35px;
  font-weight: bold;
  box-shadow: 1px 1px 10px #555;
}
</style>
